// extracted by mini-css-extract-plugin
export default {"billingResult":"Item_billingResult__aIGE0","content":"Item_content__vL8j2","date":"Item_date__Z-zv4"};